import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import demoImg from "../../Assets/demo.png";
import view from "../../Assets/View.png";
import { API_GET } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import PertnerFoodTruckDetailsModal from "./PertnerFoodTruckDetailsScreen";
import PathList from "../../Common/PathList";
import AddStateModal from "./AddStateModal";

const PAGE_SIZE_OPTIONS = [15];
const PartnerDetailsScreen = () => {
  const { id } = useParams();
  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "#",
      width: 50,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "",
      headerName: "Company Profile",
      width: 200,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              style={{ borderRadius: "8px" }}
              className="ImgHover"
              src={
                cell?.row?.food_truck_image
                  ? API_endspoints?.baseURL +
                    cell?.row?.food_truck_image[0]?.image
                  : demoImg
              }
              alt="icon"
              height={40}
              width={40}
            />
          </Box>
        </Box>
      ),
    },
    {
      headerClassName: "super-app-theme--header",
      field: "truck_name",
      headerName: "Truck Name",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "address",
      headerName: "Address",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    // {
    //   headerClassName: "super-app-theme--header",
    //   field: "description",
    //   headerName: "Description",
    //   flex: 1,
    //   minWidth: 150,
    //   headerAlign: "center",
    // },
    // {
    //   headerClassName: "super-app-theme--header",
    //   field: "truck_category",
    //   headerName: "Truck Category",
    //   flex: 1,
    //   minWidth: 150,
    //   headerAlign: "center",
    // },

    {
      headerClassName: "super-app-theme--header",
      field: "ViewDetails",
      headerName: "View Details",
      width: 150,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            onClick={() => {
              setModalData(cell.row);
              setOpenDetailsModal(true);
            }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              onClick={() => {}}
              className="ImgHover"
              src={view}
              alt="icon"
              height={24}
              width={24}
            />
          </Box>
        </Box>
      ),
    },
  ];
  // const location = useLocation();

  const [data, setData] = useState([]);
  const [loading, setloading] = useState(true);
  const [IsLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [OpenDetailsModal, setOpenDetailsModal] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [companyimg, setcompanyimg] = useState([]);
  const [active, setActive] = useState(0);
  const [certi, setCerti] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [modalData, setModalData] = useState({});

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const dataBoxStyle = {
    background: "#DEE6F252",
    width: "100%",
    height: "Hug(55px)px",
    padding: "14px",
    gap: "10px",
    borderRadius: "12px",
    color: "#164FA1",
    fontWeight: "600",
  };

  const getDetails = async (id) => {
    try {
      setloading(true);
      let res = await API_GET(
        `${API_endspoints.getcompanybyid}?company_id=${id}`
      );
      setcompanyimg(res?.r?.image?.filter((e) => e?.type === 1));
      setCerti(res?.r?.image?.filter((e) => e?.type === 2));
      setData(res.r);
      const Rowdata = res?.r?.food_truck?.map((data, i) => ({
        rowid: i + 1,
        ...data,
      }));
      setTrucks(Rowdata);
      setloading(false);
    } catch (error) {
      setloading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getDetails(id);
  }, [id]);
  return (
    // <Box sx={{ height: "calc(100vh)", background: "#F4F4F4" }}>
    <Box sx={{ height: "calc(100vh)", background: "#fff" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
          px: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            width: "calc(100% - 180px)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              mr: 2,
              boxSizing: "border-box",
            }}
          >
            <ArrowBackIosRoundedIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate(PathList._Partners)}
            />
          </Box>
          <Typography
            sx={{
              fontSize: "26px",
              fontWeight: 500,
            }}
          >
            Company Details
          </Typography>
        </Box>

        <Box
          sx={{
            background: "#DEE6F2",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            p: "10px 12px",
            borderRadius: "12px",
            color: "#164FA1",
            cursor: "pointer",
            width: "180px",
          }}
          onClick={() =>
            navigate(PathList._UserDetails, { state: data?.user_id })
          }
        >
          User Details
        </Box>
      </Box>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "85vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              gap: 5,
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
              p: 5,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                {/* Main image with blurred background */}
                <Box
                  sx={{
                    width: "100%",
                    height: {
                      xs: "200px",
                      sm: "300px",
                      md: "350px",
                      lg: "450px",
                      xl: "550px",
                    },
                    position: "relative",
                    mb: 2,
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${
                        companyimg[active]?.image
                          ? API_endspoints.baseURL + "/" + companyimg[active]?.image
                          : demoImg
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      filter: "blur(5px)",
                      zIndex: 0,
                      borderRadius: "12px",
                    },
                  }}
                >
                  <img
                    src={
                      companyimg[active]?.image
                        ? API_endspoints.baseURL + "/" + companyimg[active]?.image
                        : demoImg
                    }
                    style={{
                      borderRadius: "12px",
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      zIndex: 1,
                    }}
                    alt="preview"
                  />
                </Box>
                {/* Thumbnails */}
                <Box sx={{ display: companyimg.length > 1 ? "flex" : "none", gap: 1, mb: 2, flexWrap: "wrap" }}>
                  {companyimg &&
                    companyimg.map((x, i) => (
                      <Box
                        key={i}
                        onClick={() => setActive(i)}
                        sx={{
                          width: { xs: "70px", sm: "100px", md: "120px" },
                          height: { xs: "50px", sm: "70px", md: "80px" },
                          border: i === active ? "2px solid #CC5E02" : "2px solid transparent",
                          borderRadius: "12px",
                          overflow: "hidden",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={API_endspoints.baseURL + "/" + x?.image}
                          alt=""
                          style={{
                            borderRadius: "12px",
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    ))}
                </Box>
                <Box
                  sx={{ display: certi?.length > 1 ? "flex" : "none", gap: 1, flexWrap: "wrap" }}
                >
                  {companyimg &&
                    companyimg?.map((x, i) => {
                      return (
                        <Box
                          onClick={() => setActive(i)}
                          sx={{
                            width: { xs: "70px", sm: "100px", md: "120px" },
                            height: { xs: "50px", sm: "70px", md: "80px" },
                          }}
                        >
                          <img
                            key={i}
                            src={API_endspoints.baseURL + "/" + x?.image}
                            alt=""
                            style={{
                              borderRadius: "12px",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </Box>
                      );
                    })}
                </Box>
              </Box>
              <Box
                sx={{ mt: 3, display: certi?.length > 0 ? "block" : "none" }}
              >
                <Typography sx={{ color: "#F57C00" }}>Certificates</Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {certi?.length > 0 &&
                    certi?.map((x, i) => {
                      return (
                        <Box key={i} sx={{ width: { xs: "80px", sm: "100px", md: "120px" }, height: { xs: "80px", sm: "100px", md: "120px" } }}>
                          <img
                            src={API_endspoints.baseURL + "/" + x?.image}
                            alt="preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "12px",
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "12px", textAlign: "center" }}
                          >
                            {x?.name}
                          </Typography>
                        </Box>
                      );
                    })}
                </Box>
              </Box>
              {/* <Box> */}{" "}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: 2, sm: 5 },
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: { xs: 2, sm: 5 },
                    flexDirection: { xs: "column" },
                  }}
                >
                  <Box sx={{ width: "100%", mt: 2 }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      Type of Meals
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1.5,
                        width: "100%",
                        flexWrap: "wrap",
                      }}
                    >
                      {data?.meal?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{ ...dataBoxStyle, width: "fit-content" }}
                        >
                          <Typography>{x?.meal_name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      visibility: data?.diet?.length > 0 ? "visible" : "hidden",
                    }}
                  >
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      Type of Diet
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1.5,
                        width: "100%",
                        flexWrap: "wrap",
                      }}
                    >
                      {data?.diet?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{ ...dataBoxStyle, width: "fit-content" }}
                        >
                          <Typography>{x?.diet_name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      gap: { xs: 2, sm: 5 },
                      flexDirection: { xs: "column", md: "row" },
                      display:
                        data?.caterer?.facebook ||
                        data?.caterer?.insta ||
                        data?.caterer?.linkedin
                          ? "block"
                          : "none",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        mt: 1,
                      }}
                    >
                      <Box py={1} sx={{ fontWeight: "500" }}>
                        Social media Links
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1.5,
                          width: "100%",
                          flexWrap: "wrap",
                        }}
                      >
                        <Box
                          sx={{
                            ...dataBoxStyle,
                            display: data?.caterer?.facebook ? "block" : "none",
                            cursor: "pointer",
                            "&:hover": {
                              color: "blue",
                              textDecoration: "underline",
                            },
                          }}
                          onClick={() => window.open(data?.caterer?.facebook)}
                        >
                          <Typography>{data?.caterer?.facebook}</Typography>
                        </Box>
                        <Box
                          sx={{
                            ...dataBoxStyle,
                            display: data?.caterer?.insta ? "block" : "none",
                            cursor: "pointer",
                            "&:hover": {
                              color: "blue",
                              textDecoration: "underline",
                            },
                          }}
                          onClick={() => window.open(data?.caterer?.insta)}
                        >
                          <Typography>{data?.caterer?.insta}</Typography>
                        </Box>
                        <Box
                          sx={{
                            ...dataBoxStyle,
                            display: data?.caterer?.linkedin ? "block" : "none",
                            cursor: "pointer",
                            "&:hover": {
                              color: "blue",
                              textDecoration: "underline",
                            },
                          }}
                          onClick={() => window.open(data?.caterer?.linkedin)}
                        >
                          <Typography>{data?.caterer?.linkedin}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {/* </Box> */}
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column" },
                gap: { xs: 2, sm: 2 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column" },
                  gap: { xs: 2, sm: 2 },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: { xs: 2, sm: 2 },
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      Company Name
                    </Box>
                    <Box sx={dataBoxStyle}>
                      <Typography>{data?.company_name}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      City Name
                    </Box>
                    <Box sx={dataBoxStyle}>
                      <Typography>{data?.city}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      State
                    </Box>

                    {data?.state?.length > 0 ? (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {data?.state?.map((x, i) => (
                          <Box
                            key={i}
                            sx={{
                              ...dataBoxStyle,
                              width: "fit-content",
                              m: 0.25,
                            }}
                          >
                            <Typography>{x?.state_name}</Typography>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <AddStateModal
                        type={1}
                        id={data?.id}
                        getData={() => getDetails(id)}
                      />
                    )}
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      Web Link
                    </Box>
                    <Box
                      sx={{
                        ...dataBoxStyle,
                        cursor: "pointer",
                        "&:hover": {
                          color: "blue",
                          textDecoration: "underline",
                        },
                      }}
                      onClick={() => window.open(data?.website_link)}
                    >
                      <Typography>{data?.website_link}</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    More about company
                  </Box>
                  <Box
                    sx={{
                      ...dataBoxStyle,
                      height: "160px",
                      overflow: "scroll",
                    }}
                  >
                    <Typography>{data?.caterer?.about}</Typography>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ width: "100%" }}>
                <Box py={1} sx={{ fontWeight: "600" }}>
                  Contact Details
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Name
                  </Box>
                  <Box sx={dataBoxStyle}>
                    <Typography>{data?.user_details?.full_name}</Typography>
                  </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Email
                  </Box>
                  <Box sx={dataBoxStyle}>
                    <Link
                      to={`mailto:${data?.user_details?.email}`}
                      onMouseEnter={(e) => (e.target.style.color = "blue")}
                      onMouseLeave={(e) => (e.target.style.color = "#164FA1")}
                    >
                      <Typography>{data?.user_details?.email}</Typography>
                    </Link>
                  </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Number
                  </Box>
                  <Box sx={dataBoxStyle}>
                    <Typography>
                      +{data?.user_details?.phno_cc} {data?.user_details?.phno}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              //   background: "#F4F4F4",
              background: "#fff",
              // height: "calc(100% - 150px)",
              // width: "100%",
              // boxSizing: "border-box",
              // display: "flex",
              // gap: 2,
              p: 5,
            }}
          >
            {/* <UserDetailsSideBar /> */}
            <Box sx={{ height: "400px" }}>
              <Typography sx={{ my: 1, color: "#F57C00" }}>
                Food Trucks
              </Typography>
              <DataListingComponent
                data={trucks ?? []}
                PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
                loading={IsLoading}
                totalData={totalData}
                page={page}
                Footer={false}
                columns={column}
                rowsPerPage={rowsPerPage}
                handlePageChange={handlePageChange}
                handleRowsPerPageChange={handleRowsPerPageChange}
              />
            </Box>
          </Box>
          <PertnerFoodTruckDetailsModal
            data={modalData}
            setOpen={setOpenDetailsModal}
            open={OpenDetailsModal}
            getDetails={() => getDetails(id)}
          />
        </>
      )}
    </Box>
  );
};

export default PartnerDetailsScreen;
